export const ADMIN_VERIFICATION_DEADLINE = "11-01T00:00:00";

export const VESTING_PERCENTAGE = 0.25;
export const VESTING_YEARS = 5;

export const MODULE_COUNT = 5;

export const CROPS_SCHEMA = {
  biodiversityBenifits: { de: [], en: [], pl: [] },
  enabled: true,
  id: "",
  name: { de: "", en: "", pl: "" },
  neutral: { de: false, en: false, pl: false },
  onlyVisibleToAdmins: false,
  recommendSplit: null,
  residue: { de: 0, en: 0, pl: 0 },
  synonyms: { de: [], en: [], pl: [] },
  isMainCrop: false,
  isCatchCrop: false,
  isUndersowing: false,
  isGrassland: false,
  isPerennial: false,
  isWinterCrop: false,
  isLegume: false,
  recommendSideCrop: false,
};

export const TILLAGE_SEEDING_SCHEMA = {
  id: "",
  name: { de: "", en: "", pl: "" },
  dieselUsage: { de: 0, en: 0, pl: 0 },
  enabled: true,
  onlyVisibleToAdmins: false,
  recommendSplit: null,
  synonyms: { de: [], en: [], pl: [] },
};

export const FERTILIZERS_APPLICATION_SCHEMA = {
  id: "",
  name: { de: "", en: "", pl: "" },
  manureMultiplier: { de: 0, en: 0, pl: 0 },
  dungMultiplier: { de: 0, en: 0, pl: 0 },
  enabled: true,
  synonyms: { de: [], en: [], pl: [] },
};

export const FERTILIZERS_APPLICATION_MINERALS_SCHEMA = {
  id: "",
  name: { de: "", en: "", pl: "" },
  co2Value: { de: 0, en: 0, pl: 0 },
  ammonia: { de: 0, en: 0, pl: 0 },
  nValue: { de: 0, en: 0, pl: 0 },
  enabled: true,
  synonyms: { de: [], en: [], pl: [] },
};

export const FERTILIZERS_APPLICATION_ORGANICS_SCHEMA = {
  id: "",
  name: { de: "", en: "", pl: "" },
  co2Value: { de: 0, en: 0, pl: 0 },
  tanPart: { de: 0, en: 0, pl: 0 },
  mineralEquivalent: { de: 0, en: 0, pl: 0 },
  nValue: { de: 0, en: 0, pl: 0 },
  type: "",
  enabled: true,
  synonyms: { de: [], en: [], pl: [] },
};
